// import axios from 'axios';
import axios from '../utils/http';


const news = {

    // 返回所有的directions
    getNews() {
        return axios.get('api/v1/news');
    }
}

export default news;
